import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import CustomDnsCertificate from 'mbs-ui-shared@models/CustomDnsCertificate';
import { PagedResponse } from 'mbs-ui-shared@models/Paging';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomDnsCertificatesService {
  private http = inject(HttpClient);

  private readonly controllerPath = 'api/customdns/certificates/';

  public get(): Observable<PagedResponse<CustomDnsCertificate>> {
    return this.http.get<PagedResponse<CustomDnsCertificate>>(this.controllerPath);
  }

  public uploadCertificate({ certificate, password }): Observable<CustomDnsCertificate> {
    const formData = new FormData();

    formData.append('certificate', certificate);
    formData.append('type', 'own');
    formData.append('password', password);

    return this.http.post<CustomDnsCertificate>(this.controllerPath, formData as any);
  }
}
